import React, { useCallback, useMemo, useState } from 'react';
import HashLink from 'components/HashLink';
import { Collapse } from 'components/Transition';
import classlist from 'utils/classlist';

export interface TelcodesSelectionProps {
    telcodes: Array<{
        letter: string;
        items: Array<{
            tel_code: number;
            country_code: string;
            country: string;
        }>;
    }>;
    value: string;
    onChange(v): void;
    countryValueKey: 'country_code' | 'tel_code' | 'country_code2';
    isTel?: boolean;
}

const PC: React.FC<TelcodesSelectionProps> = ({ telcodes, onChange, isTel, countryValueKey }) => {
    const [visible, setVisible] = useState(false);
    const [activeId, setActive] = useState(telcodes[0].letter);
    const hide = useCallback(() => setVisible(false), []);
    const handleVisible = useCallback(
        node => {
            if (node) {
                window.addEventListener('click', hide, false);
            } else {
                window.removeEventListener('click', hide, false);
            }
        },
        [hide]
    );
    const countryItems = useMemo(
        () => telcodes.find(({ letter }) => letter === activeId)?.items ?? [],
        [activeId, telcodes]
    );

    return (
        <>
            <Collapse in={visible} timeout={400}>
                <div className="pc-selection" ref={handleVisible} onClick={ev => ev.stopPropagation()}>
                    <div className="navs">
                        {telcodes.map(({ letter }) => (
                            <HashLink
                                onClick={ev => {
                                    setActive(letter);
                                }}
                                key={letter}
                                title={letter}
                                className={activeId === letter ? 'active' : undefined}>
                                {letter}
                            </HashLink>
                        ))}
                    </div>
                    <div className="countries">
                        {countryItems.map(item => (
                            <HashLink
                                key={item[countryValueKey]}
                                title={`${item.country} +${isTel ? item.tel_code : item[countryValueKey]}`}
                                onClick={() => {
                                    onChange(item);
                                    hide();
                                }}>
                                <span className="tc-country text-truncate">{item.country}</span>{' '}
                                <span className="tc-code">{isTel ? `+${item.tel_code}` : item[countryValueKey]}</span>
                            </HashLink>
                        ))}
                    </div>
                </div>
            </Collapse>
            <div
                className={classlist('trigger', visible && 'is-visible')}
                onClick={ev => {
                    ev.stopPropagation();
                    setVisible(!visible);
                }}
                title={__('选择手机号所在地区')}>
                select
            </div>
        </>
    );
};

export default PC;
